import { state, transition, invoke, createMachine, reduce } from 'robot3';
import { isWpSuccess, wpFetchRestApi } from '../../util';
const machine = {
    idle: state(transition('cancel', 'cancelling')),
    cancelling: invoke(cancel, transition('done', 'idle', reduce(storeNrCancelled)), transition('error', 'error', reduce(storeError))),
    error: state(transition('cancel', 'cancelling')),
};
export function create() {
    return createMachine('idle', machine, (ctx) => (Object.assign({}, ctx)));
}
function storeError(ctx, ev) {
    return Object.assign(Object.assign({}, ctx), { error: ev.error.message });
}
function storeNrCancelled(ctx, ev) {
    return Object.assign(Object.assign({}, ctx), { nr_cancelled: ev.data.nr_of_meetings_cancelled, error: undefined });
}
async function cancel() {
    const endpoint = 'meeting/cancel-with-deadline';
    const result = await wpFetchRestApi(endpoint, 'GET');
    if (isWpSuccess(result)) {
        return result.data;
    }
    throw new Error(result.message);
}
